export class Permissions {
  public club?: ClubPermissions;
  public clubAttributes: ClubAttributesPermissions;
  public customerAttributes: CustomerAttributesPermissions;
  public typesAllowed: TypesAllowedPermissions;
  public user: UserPermissions;
  public campaiMembership: CampaiMembershipPermissions;
  public membership: MembershipPermissions;

  constructor(permissions: any) {
    this.club = new ClubPermissions(permissions.club);
    this.clubAttributes = new ClubAttributesPermissions(permissions.clubAttributes);
    this.customerAttributes = new CustomerAttributesPermissions(permissions.customerAttributes);
    this.typesAllowed = new TypesAllowedPermissions(permissions.typesAllowed);
    this.user = new UserPermissions(permissions.user);
    this.campaiMembership = new CampaiMembershipPermissions(permissions.campaiMembership);
    this.membership = new MembershipPermissions(permissions.membership);
  }
}

export class ClubPermissions {
  public list?: boolean;
  public add?: boolean;
  public settings?: boolean;

  constructor(permissions?: any) {
    this.list = permissions.list;
    this.add = permissions.add;
    this.settings = permissions.settings;
  }
}

export class ClubAttributesPermissions {
  public list: boolean;
  public add: boolean;

  constructor(permissions: any) {
    this.list = permissions.list;
    this.add = permissions.add;
  }
}

export class CustomerAttributesPermissions {
  public list: boolean;
  public assign: boolean;

  constructor(permissions: any) {
    this.list = permissions.list;
    this.assign = permissions.assign;
  }
}

export class TypesAllowedPermissions {
  public admin: boolean;
  public callCenterAgent: boolean;
  public clubAdmin: boolean;
  public ticketAgent: boolean;

  constructor(permissions: any) {
    this.admin = permissions.admin;
    this.callCenterAgent = permissions.callCenterAgent;
    this.clubAdmin = permissions.clubAdmin;
    this.ticketAgent = permissions.ticketAgent;
  }
}

export class UserPermissions {
  public list: boolean;
  public add: boolean;
  public settings: boolean;

  constructor(permissions: any) {
    this.list = permissions.list;
    this.add = permissions.add;
    this.settings = permissions.settings;
  }
}

export class CampaiMembershipPermissions {
  public transfer?: boolean;

  constructor(permissions?: any) {
    this.transfer = permissions?.transfer;
  }
}

export class MembershipPermissions {
  public add?: boolean;
  public delete?: boolean;

  constructor(permissions?: any) {
    this.add = permissions?.add;
    this.delete = permissions?.delete;
  }
}
